/** Globalny nagłówek: megamenu, boczne zakładki, mobilne akordeony i sticky header. */
document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.kpg-hd');
    if (!header) return;
    const desktop = window.matchMedia('(min-width: 1280px)');
    const hover = window.matchMedia('(hover: hover)');
    const toggle = header.querySelector('.kpg-hd__toggle');
    const nav = header.querySelector('.kpg-hd__nav');
    const items = [...header.querySelectorAll('.has-mega')];
    const controllers = items.map(item => ({
        item,
        trigger: item.querySelector('.kpg-hd__item'),
        menu: item.querySelector('.kpg-mega'),
        tabs: [...item.querySelectorAll('.kpg-mega__tab')],
        panes: [...item.querySelectorAll('.kpg-mega__pane')],
        closeTimer: null,
    }));
    header.classList.add('is-js');

    const setOpen = (controller, open) => {
        window.clearTimeout(controller.closeTimer);
        controller.item.classList.toggle('is-open', open);
        controller.trigger.setAttribute('aria-expanded', String(open));
        controller.menu.hidden = !open;
    };
    const closeAll = except => controllers.forEach(controller => {
        if (controller !== except) setOpen(controller, false);
    });
    const setMobileOpen = open => {
        header.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        nav.hidden = !desktop.matches && !open;
        if (!open) closeAll();
    };
    const selectTab = (controller, index, focus = false) => {
        controller.tabs.forEach((tab, i) => {
            const selected = i === index;
            tab.classList.toggle('is-on', selected);
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            if (selected && focus) tab.focus();
        });
        controller.panes.forEach((pane, i) => {
            pane.classList.toggle('is-on', i === index);
            pane.hidden = desktop.matches && i !== index;
        });
    };
    controllers.forEach(controller => {
        controller.trigger.addEventListener('click', () => {
            const open = controller.menu.hidden;
            closeAll(controller);
            setOpen(controller, open);
        });
        controller.trigger.addEventListener('keydown', event => {
            if (!desktop.matches || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
            event.preventDefault();
            closeAll(controller);
            setOpen(controller, true);
            const targets = [...controller.menu.querySelectorAll('a[href], button')]
                .filter(element => !element.closest('[hidden]') && element.getClientRects().length);
            const target = event.key === 'ArrowDown' ? targets[0] : targets.at(-1);
            target?.focus();
        });
        controller.item.addEventListener('pointerenter', event => {
            if (!desktop.matches || !hover.matches || event.pointerType === 'touch') return;
            closeAll(controller);
            setOpen(controller, true);
        });
        controller.item.addEventListener('pointerleave', () => {
            if (!desktop.matches) return;
            controller.closeTimer = window.setTimeout(() => {
                if (!controller.item.contains(document.activeElement)) setOpen(controller, false);
            }, 200);
        });
        controller.item.addEventListener('focusout', () => {
            window.setTimeout(() => {
                if (!controller.item.contains(document.activeElement) && !controller.item.matches(':hover')) setOpen(controller, false);
            }, 0);
        });
        controller.tabs.forEach((tab, index) => {
            tab.addEventListener('pointerenter', event => {
                if (desktop.matches && hover.matches && event.pointerType !== 'touch') selectTab(controller, index);
            });
            tab.addEventListener('focus', () => {
                if (desktop.matches) selectTab(controller, index);
            });
            tab.addEventListener('click', () => selectTab(controller, index));
            tab.addEventListener('keydown', event => {
                if (!desktop.matches) return;
                let next;
                if (event.key === 'ArrowDown') next = (index + 1) % controller.tabs.length;
                if (event.key === 'ArrowUp') next = (index - 1 + controller.tabs.length) % controller.tabs.length;
                if (event.key === 'Home') next = 0;
                if (event.key === 'End') next = controller.tabs.length - 1;
                if (next !== undefined) { event.preventDefault(); selectTab(controller, next, true); }
            });
        });
        controller.panes.forEach(pane => {
            const accordion = pane.querySelector('.kpg-mega__pt');
            const body = pane.querySelector('.kpg-mega__pb');
            accordion.addEventListener('click', () => {
                if (desktop.matches) return;
                const open = body.hidden;
                body.hidden = !open;
                pane.classList.toggle('is-open', open);
                accordion.setAttribute('aria-expanded', String(open));
            });
        });
    });
    toggle.addEventListener('click', () => setMobileOpen(!header.classList.contains('is-open')));
    document.addEventListener('click', event => {
        if (!header.contains(event.target)) setMobileOpen(false);
    });
    nav.addEventListener('click', event => {
        if (event.target.closest('a[href]')) setMobileOpen(false);
    });
    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = controllers.find(controller => !controller.menu.hidden);
        if (open) { setOpen(open, false); open.trigger.focus(); }
        else if (header.classList.contains('is-open')) { setMobileOpen(false); toggle.focus(); }
    });

    const syncViewport = () => {
        const active = document.activeElement;
        setMobileOpen(false);
        controllers.forEach(controller => {
            const list = controller.item.querySelector('.kpg-mega__cats');
            if (list) {
                if (desktop.matches) {
                    list.setAttribute('role', 'tablist');
                    list.setAttribute('aria-orientation', 'vertical');
                } else { list.removeAttribute('role'); list.removeAttribute('aria-orientation'); }
            }
            controller.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
            controller.panes.forEach((pane, index) => {
                pane.classList.remove('is-open');
                pane.setAttribute('role', desktop.matches ? 'tabpanel' : 'region');
                pane.setAttribute('aria-labelledby', pane.id + (desktop.matches ? '-tab' : '-accordion'));
                pane.querySelector('.kpg-mega__pb').hidden = !desktop.matches;
                const accordion = pane.querySelector('.kpg-mega__pt');
                accordion.setAttribute('aria-expanded', 'false');
                controller.tabs[index].setAttribute('aria-controls', pane.id);
            });
            selectTab(controller, 0);
        });
        if (active && nav.contains(active)) {
            if (desktop.matches) header.querySelector('.kpg-hd__item')?.focus();
            else toggle.focus();
        }
        updateGeometry();
    };
    const adminBar = document.getElementById('wpadminbar');
    let pending = false;
    let anchorOffset;
    let updateHomeState = () => {};
    const updateGeometry = () => {
        const offset = adminBar ? Math.max(0, adminBar.getBoundingClientRect().bottom) : 0;
        header.style.setProperty('--kpg-admin-offset', `${offset}px`);
        header.classList.toggle('is-stuck', window.scrollY > 40);
        const headerBottom = Math.ceil(header.getBoundingClientRect().bottom);
        header.style.setProperty('--kpg-header-bottom', `${headerBottom}px`);
        if (anchorOffset !== headerBottom + 12) {
            anchorOffset = headerBottom + 12;
            document.documentElement.style.setProperty('--kpg-anchor-offset', `${anchorOffset}px`);
        }
        updateHomeState();
        pending = false;
    };
    const scheduleUpdate = () => {
        if (!pending) { pending = true; window.requestAnimationFrame(updateGeometry); }
    };
    desktop.addEventListener('change', syncViewport);
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    if (window.ResizeObserver) new ResizeObserver(scheduleUpdate).observe(header);
    syncViewport();

    // Aktywne pozycje na podstronach; kotwice strony głównej obsługiwane oddzielnie.
    const topItems = [...header.querySelectorAll('.kpg-hd__mi')];
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    const inquiryCode = new URLSearchParams(window.location.search).get('u');
    topItems.forEach(item => {
        const current = [...item.querySelectorAll('a[href]')].filter(link => !link.closest('.kpg-mega__cta')).find(link => {
            const url = new URL(link.href, window.location.href);
            return url.origin === window.location.origin && (url.pathname.replace(/\/$/, '') || '/') === path
                && url.searchParams.get('u') === inquiryCode && path !== '/';
        });
        if (current) {
            item.querySelector('.kpg-hd__item').classList.add('is-active');
            current.setAttribute('aria-current', 'page');
        }
    });
    const home = document.querySelector('.homepage');
    if (home) {
        const offer = home.querySelector('#oferta');
        const sections = ['o-nas', 'zespol'].map(id => home.querySelector('#' + id)).filter(Boolean);
        updateHomeState = () => {
            const marker = window.innerHeight * 0.35;
            let category = '';
            if (offer) {
                const rect = offer.getBoundingClientRect();
                if (rect.top < marker && rect.bottom > marker) category = offer.querySelector('[data-kpg-tab][aria-selected="true"]')?.dataset.kpgTab || '';
            }
            sections.forEach(section => {
                const rect = section.getBoundingClientRect();
                if (rect.top < marker && rect.bottom > marker) category = section.id;
            });
            topItems.forEach(item => {
                const trigger = item.querySelector('.kpg-hd__item');
                const active = Boolean(category) && (trigger.dataset.cat || '').split(/\s+/).includes(category);
                trigger.classList.toggle('is-active', active);
                if (active) trigger.setAttribute('aria-current', 'location');
                else if (trigger.getAttribute('aria-current') === 'location') trigger.removeAttribute('aria-current');
            });
        };
        if (offer && window.MutationObserver) new MutationObserver(scheduleUpdate).observe(offer, { attributes: true, attributeFilter: ['aria-selected'], subtree: true });
        updateHomeState();
    }
});

/** Kotwice wspólne dla wszystkich szablonów. Lokalne zakładki mają pierwszeństwo. */
document.addEventListener('DOMContentLoaded', () => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href]');
        if (link?.matches('.comment-reply-link, #cancel-comment-reply-link')) return;
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '') || url.search !== window.location.search || !url.hash) return;
        let id;
        try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target) return;
        // Zakładki ujawniają panel i przewijają go we własnym skrypcie.
        if (target.getAttribute('role') === 'tabpanel') return;
        event.preventDefault();
        if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
        const header = document.querySelector('.kpg-hd');
        if (header) document.documentElement.style.setProperty('--kpg-anchor-offset', `${Math.ceil(header.getBoundingClientRect().bottom) + 12}px`);
        target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
        const focus = target.querySelector('h1, h2, h3') || target;
        if (!focus.matches('a[href], button, input, select, textarea, [tabindex]')) focus.setAttribute('tabindex', '-1');
        focus.focus({ preventScroll: true });
    });
});

